import type { FC, ReactElement } from 'react';

import { L10nText } from '../../../services/uiTranslations/reactBindings/L10nText';
import { useCoreDispatch } from '../../../store/CoreStore';
import { gameStateActions } from '../../../store/slices/game/slice';
import { popupActions } from '../../../store/slices/popup/slice';
import { getWindowObject } from '../../../utils/window';
import { Button, ButtonVariant } from '../../controls/button/Button';
import type { OnCloseCallback } from '../../popup/types';
import { PopupType } from '../../popup/types';

import { BlockingModalContent } from './BlockingModalContent';

export const LoggedOutConnected: FC = (): ReactElement => {
  const dispatch = useCoreDispatch();

  const action = [
    <Button
      key="OK"
      tk="OK"
      variant={ButtonVariant.ACCENT}
      onClick={() => {
        loggedOutClose(dispatch);
      }}
    />,
  ];

  return (
    <BlockingModalContent actions={action}>
      <L10nText tk="LOGGED_OUT_ERROR" />
    </BlockingModalContent>
  );
};

export const loggedOutClose: OnCloseCallback = (dispatch): void => {
  const windowObject = getWindowObject();
  dispatch(popupActions.dismissPopup(PopupType.LoggedOut));
  dispatch(gameStateActions.setGamePaused(false));
  windowObject.location.reload();
};
